import BookingList from './BookingsList';

export default BookingList;
